
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerBKIConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/constants/ib-datalayer-bki-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import angular from 'angular';
import { CallAncillariesPageService } from '../../../../features/services/services/services/ib-call-ancillaries-service';
import { AncillariesTransformer } from '../../../../features/transformers/ib-web-ancillaries-transformer';


const componentOptions = {
    bindings: {
        bidsOpen: '=',
        bidsClosed: '=',
        totalBidsOpen: '=',
        available: '=',
        modules: '=',
        dataequalrow: '=',
        view: '=',
        index: '=',
        last: '=',
        aviosBidAvailable:'=',
        waitingListAvailable: '='
    },
    controllerAs: 'ibBidsBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-bids-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-bids-box-module',
    selector: 'ibBidsBox',
    inject: ['$scope', 'localStorageService', 'CurrencyService', 'CallAncillariesPageService', 'AncillariesTransformer', 'ModalServiceAncillaries', 'CommonsConstants', 'DatalayerUtilsService', '$rootScope', 'AncillariesConstants', 'DatalayerConstants'],
    required: ['']
};

export class ibBidsBox implements ng.IController {

    public aviosBidAvailable: boolean;
    public availablePrice;
    public available;
    public upgradingBidsInfo;
    public tierIB: string;
    totalAmountOpenBids: number;
    totalAmountOpenBidsFormatted: string;
    constructor (
        private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService,
        private CallAncillariesPageService: CallAncillariesPageService,
        private AncillariesTransformer: AncillariesTransformer,
        private ModalServiceAncillaries: any,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $rootScope: CommonsRootScope,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerConstants: DatalayerConstantsType) {
        this.$scope.$on('refreshBidsBoxModule', this.refreshBidsBoxModule);
    }

    $onInit () {
        const currency: CommonsCurrencyModel.CurrencyResponse = this.localStorageService.get('currency');
        const confirmationDigitalInfo: any = this.localStorageService.get('confirmationDigitalInfo');
        this.availablePrice = this.aviosBidAvailable ? this.CurrencyService.formatAvios(currency, this.available, false, false, false) : this.CurrencyService.formatPrice(currency, this.available, false, false, false);
        this.upgradingBidsInfo = this.localStorageService.get('upgradingBidsInfo');
        this.totalAmountOpenBids = this.localStorageService.get('totalAmountBids');
        this.totalAmountOpenBidsFormatted = this.totalAmountOpenBids ? this.CurrencyService.formatPrice(currency, this.totalAmountOpenBids, false, false, false) : 0;
        this.tierIB = this.checkAndFormatIberiaMemberLevel(confirmationDigitalInfo?.UserLevel);
    }

    generateUpgTypeForDigitalData = () => {
        const upgInfo: any = this.localStorageService.get('upgradingBidsInfo');
        let text = '';
        upgInfo.ancillariesTrips.forEach((trip) => {
            text += `${trip.currentCabin}=>`;
            const bidsSegmentFilteredByIdTrip = upgInfo.bidsSegments.filter((bid)=> bid.id === trip.id);
            bidsSegmentFilteredByIdTrip.map((bidFilteredByTrip)=> bidFilteredByTrip.availableCabins.map((availableCabin)=> text += `${availableCabin.cabinType} `));
        });
        return {upgType: text.trim()};
    };

    openBidsFlow = (): void => {
        this.localStorageService.set('close', this.AncillariesConstants.QUADRIGAM.ANCILLARIES_MMB);
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_UPGRADING, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        const UpgType = this.generateUpgTypeForDigitalData();
        this.DatalayerUtilsService.addDigitalDataInfo(UpgType);
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_UPGRADING, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
        this.$scope.$emit('openUpgradingBids');
    };

    refreshBidsBoxModule = (): any => {
        let transformData;
        const bookingInfo = this.localStorageService.get('bookingInfo');
        this.CallAncillariesPageService.getUpgradingBidAncillarie().then((response) => {
            transformData = this.AncillariesTransformer.generateInfoManageMyBooking(response, bookingInfo);
            this.availablePrice = transformData.bidsUpgradingInfo.totalAmountBidsFormated;
        }, (error) => {
            this.ModalServiceAncillaries.showGenericError(error).result.then(angular.noop, angular.noop);
        });
    };

    /*
     * Checks what Iberia member level the user has and formats it
     */
    checkAndFormatIberiaMemberLevel = (userLevel) => {
        let iberiaMemberLevelFormatted:string;
        switch(userLevel) {
                case 'CLASICA':
                    iberiaMemberLevelFormatted = 'Clásica';
                    break;
                case 'PLATA':
                    iberiaMemberLevelFormatted = 'Plata';
                    break;
                case 'ORO':
                    iberiaMemberLevelFormatted = 'Oro';
                    break;
                case 'PLATINO':
                    iberiaMemberLevelFormatted = 'Platino';
                    break;
                case 'INFINITA':
                    iberiaMemberLevelFormatted = 'Infinita';
                    break;
                case 'INFINITA PRIME':
                    iberiaMemberLevelFormatted = 'Infinita Prime';
                    break;
        }
        return iberiaMemberLevelFormatted;
    };
}

try {
    const mod = angular.module(componentInfo.module);
    ibBidsBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBidsBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBidsBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBidsBox })
    );
}